import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');
import { Card } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const ChannelStore = require('../../stores/channel_store_reflux');
const ProjectStore = require('../../stores/ProjectStore');
const CollaboratorStore = require('../../stores/CollaboratorStore');
import ProjectCollaborators from '../project/ProjectCollaborators';
import ExpansionButton from '../common/ExpansionButton';

const propTypes = {
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    orgMembers: PropTypes.array.isRequired,
    className: PropTypes.string
};

const defaultProps = {
    className: ''
};

class OrgProjectPermissionsTile extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            projectStoreState: ProjectStore.getStateProject(this.props.projectId),
            channelStoreState: ChannelStore.getState(),
            collaboratorStoreState: CollaboratorStore.getStateProject(this.props.projectId),
            expanded: false,
        };

        this.onHeadingClick = this.onHeadingClick.bind(this);
        this.toggleExpanded = this.toggleExpanded.bind(this);

        this.unsubscribes = [
            ChannelStore.listen(this.onStoreChange.bind(this, 'channelStoreState')),
            ProjectStore.listen(this.onProjectStoreStateChange.bind(this)),
            CollaboratorStore.listen(this.onCollaboratorStoreStateChange.bind(this)),
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onStoreChange(storeStateName, newState) {
        this.setState({ [storeStateName]: newState });
    }

    onProjectStoreStateChange(newState) {
        this.setState({ projectStoreState: ProjectStore.getStateProject(this.props.projectId) });
    }

    onCollaboratorStoreStateChange(newState) {
        this.setState({ collaboratorStoreState: CollaboratorStore.getStateProject(this.props.projectId) });
    }

    onHeadingClick(e) {
        this.toggleExpanded();
    }

    toggleExpanded() {
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        let projectName = '';
        let canEditCollabs = false;
        const pCollabs = this.state.collaboratorStoreState.pCollaborators || {};
        const collabCount = pCollabs.length || 0;
        let isOrgProject = false;
        let orgPossibleCollaborators = [];

        if (this.state.channelStoreState.initialized && this.state.projectStoreState.initialized) {
            const project = this.state.projectStoreState.project;
            const channel = this.state.channelStoreState.channelsAndOrgs.find(c => c.id === project.channelId);

            if (!PermissionsUtil.canViewProjectCollaborators(channel.user_permissions, project.user_permissions)) {
                return null;
            }

            canEditCollabs = PermissionsUtil.canEditProjectCollaborators(channel.user_permissions, project.user_permissions);
            isOrgProject = Globals.users.is_org_account_type(channel.channel_account_type_token);
            if (isOrgProject) {
                orgPossibleCollaborators = this.props.orgMembers;
            }

            projectName = project.name;
        }

        return (
            <div className={`margin-top-lg ${this.props.className}`}>
                <Card body bg="light" className="padding-lr-md">
                    <div className={this.props.expanded ? "termListing" : "termListing--noBorder"} onClick={this.onHeadingClick} role="button">
                        <h1 className="termListing__termContainer font-weight-bold">
                            {`${projectName} (${collabCount})`}
                        </h1>
                        <ExpansionButton className="termListing__control" expanded={this.state.expanded} onClick={this.toggleExpanded} />
                    </div>
                    { this.state.expanded &&
                        <ProjectCollaborators
                            projectId={this.props.projectId}
                            canEdit={canEditCollabs}
                            isOrgProject={isOrgProject}
                            orgPossibleCollaborators={orgPossibleCollaborators}
                        />
                    }
                </Card>

            </div>
        );
    }
}

OrgProjectPermissionsTile.propTypes = propTypes;
OrgProjectPermissionsTile.defaultProps = defaultProps;

export default OrgProjectPermissionsTile;